import { defaultTheme, themeLocalStorageKey } from './shared'

export const getThemeInitScript = () => `
(function () {
  var themeToSet = '${defaultTheme}'
  window.localStorage.setItem('${themeLocalStorageKey}', themeToSet)
  document.documentElement.setAttribute('data-theme', themeToSet)
  document.documentElement.classList.add('dark')
})();
`
